<template>
  <a-modal
    v-model:visible="visible"
    :maskClosable="false"
    :footer="null"
    :width="600"
  >
    <h2>Contact Us</h2>
    <div class="content">
      <div style="padding-top: 30px; text-align: center;">
        <a-space size="large">
          <a target=_blank href="https://www.facebook.com/digirebar?mibextid=wwXIfr&mibextid=wwXIfr"><img src="@/assets/facebook.png" alt="" class="logo-img" /></a>
          <a target=_baank href="mailto:qianx768@gmail.com"><img src="@/assets/gmail.png" alt="" class="logo-img" /></a>
        </a-space>
      </div>
      <p style="padding-top: 20px; text-align: center;font-size: 16px">qianx768@gmail.com<br>+8613651872393<br>+8602150116038</p>
    </div>
  </a-modal>
</template>

<script>
import { ref } from "vue";
export default {
  name: "ContactUs",
  setup() {
    const visible = ref(false);
    const showModal = () => {
      visible.value = true;
    };
    return {
      visible,
      showModal,
    };
  },
};
</script>

<style lang="less" scoped>
.content {
  height: 240px;
  overflow: auto;
  //   margin-top: 20px;
}
.bold {
  font-weight: 700;
}
p {
  line-height: 2;
}
.logo-img {
  width: 100px;
  border-radius: 4px;
  transition: transform 0.3s ease; /* 添加平滑过渡效果 */
  
}
.logo-img:hover {
  transform: scale(1.2);
}
</style>